import { Controller } from '@hotwired/stimulus'

// Back navigation on the customers overview forces a full Turbolinks reload,
// which drops the "show" state of the per-company users-list collapses.
// Remember which ones were expanded so we can reopen them after reload.
const STORAGE_KEY = 'expandedCompanyUserLists'

export default class extends Controller {
  connect() {
    this.restoreExpanded()
    this.element.addEventListener('shown.bs.collapse', this.onShown)
    this.element.addEventListener('hidden.bs.collapse', this.onHidden)
  }

  disconnect() {
    this.element.removeEventListener('shown.bs.collapse', this.onShown)
    this.element.removeEventListener('hidden.bs.collapse', this.onHidden)
  }

  onShown = (event) => this.setExpanded(event.target.id, true)
  onHidden = (event) => this.setExpanded(event.target.id, false)

  restoreExpanded() {
    const expandedIds = this.readExpandedIds()
    this.element.querySelectorAll('.users-list').forEach((list) => {
      if (expandedIds.includes(list.id)) list.classList.add('show')
    })
  }

  setExpanded(id, expanded) {
    const ids = new Set(this.readExpandedIds())
    expanded ? ids.add(id) : ids.delete(id)
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify([...ids]))
  }

  readExpandedIds() {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]')
    } catch {
      return []
    }
  }
}
